import { InformationCircleIcon } from '@heroicons/react/24/outline';
import Tooltip from 'antd/es/tooltip';

import { formatDecimalAmount } from 'utils/formatters/formatCurrency';

import type { PayoutBatch } from 'api';

import { DetailsBatchAttachmentSectionContainer } from '@atoms/DetailsAttachmentSection/DetailsBatchAttachmentSectionContainer';

import { ActivityDetails } from './ActivityDetails';
import type { CollapseItemWithTypedSection } from './BatchDetails';
import { ViewPayoutsButton } from './ViewPayoutsButton';

export const getCollapseItems = (
  payoutBatchData: PayoutBatch | undefined,
  isSuccess: boolean
): CollapseItemWithTypedSection[] => {
  if (!payoutBatchData || !isSuccess) {
    return [];
  }

  const sections: CollapseItemWithTypedSection[] = [];

  sections.push(
    {
      key: 'batch',
      label: 'Batch',
      children: (
        <div>
          <ActivityDetails
            createdAt={payoutBatchData.created_at}
            createdBy={payoutBatchData.creator_name}
          />
          <div className="break-words py-2">
            <p className="text-base text-content-secondary">Amount</p>
            {payoutBatchData.total_amount != null && (
              <div>
                {formatDecimalAmount(payoutBatchData.total_amount)}{' '}
                {payoutBatchData.currency?.iso}
              </div>
            )}
          </div>
          <div className="break-words py-2">
            <p className="text-base text-content-secondary">Transfer type</p>
            <p className="pb-2 text-base font-medium">
              {payoutBatchData.local_instrument}
            </p>
          </div>
          <ViewPayoutsButton
            batchId={payoutBatchData.id}
            totalPayoutRequestsCount={
              payoutBatchData.total_payout_requests_count
            }
          />
        </div>
      )
    },
    {
      key: 'attachments',
      label: (
        <div className="flex items-center gap-1">
          Attachments
          <Tooltip
            title="This feature is not intended for RFIs"
            placement="right"
            arrow={true}
          >
            <InformationCircleIcon className="size-4 stroke-current" />
          </Tooltip>
        </div>
      ),
      children: (
        <DetailsBatchAttachmentSectionContainer
          resourceId={payoutBatchData.id}
        />
      )
    }
  );

  return sections;
};
